import { Link } from 'react-router-dom'

function NotFoundPage() {
  return (
    <div className="pg-layout">
      <div className="text-center">
      <h1 className="text-[36px] sm:text-[48px] md:text-[56px] font-normal leading-[1.02] tracking-[-1.8px] mb-4">404</h1>
      <p className="text-base text-soft-dim mb-2">This page does not exist.</p>
      <p className="text-sm text-soft-faint mb-8">
        It was removed in a refactor. Or never existed. Hard to say.
      </p>
      <Link
        to="/"
        className="inline-flex px-6 py-3 bg-soft-ink text-soft-bg text-sm no-underline hover:opacity-90 transition-opacity"
      >
        Go home →
      </Link>
      </div>
      <div />
    </div>
  )
}

export default NotFoundPage
